import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'

// Components
import { App } from '../../../App';
import { ModelList } from '../../../components/PaginatedList/ModelList';


// Redux
import { createPerson } from './redux/people.actions';
import { FullPeople } from './redux/people.selectors';
import { PeopleList } from './PeopleList';
import { hasAccess } from '../../services/CaptureCollabService';
import { SmartContainer, StyledGridItem, Surface } from '../../../styles/Containers';
import { NewContent } from '../../../components/Content/NewContent';

export const PeoplePage = () => {

    // New Modal
    const dispatch = useDispatch();
    const store = FullPeople();

    // --------------------------
    // Effects
    // --------------------------

    useEffect(() => {
        if (store.createSuccess) {

            // Redirect to edit page
            dispatch(push(`/people/${store.create.id}/settings`))
        }
    }, [store.createLoading])

    // --------------------------
    // Interactions
    // --------------------------

    // On Select
    const handleSelect = (item) => {
        dispatch(push(`/people/${item.id}`))
    }

    // --------------------------
    // Renders
    // --------------------------
    const renderTopBarChildren = () => {



        return (
            <SmartContainer flex align="center" justify="flex-end">
                <NewContent buttonText="Create A New Person" label="New Person" selector={FullPeople} createAction={createPerson} />
            </SmartContainer>
        )

    }

    const renderNewTile = () => {
        return (
            <StyledGridItem key="newtile">
                <Surface flex justify="center" align="center" width="100%">
                    <NewContent iconHelperText="New Person" label="New Person" selector={FullPeople} createAction={createPerson} />
                </Surface>
            </StyledGridItem>
        )
    }


    // Render Page
    return (
        <App title="People" topBarChildren={renderTopBarChildren()}
            breadcrumbs={[{ href: `/people`, title: 'People' }, { href: `/locations`, title: 'Locations' }, { href: `/tags`, title: 'Tags' }]}>

            <PeopleList onSelect={handleSelect} />

        </App>
    )
}